import React from "react";
import _ from "lodash";
import { connect } from "formik";
import { IntegerInput } from "components/Global/FormikMaterial";
import { Tooltip } from "@material-ui/core";

import ViewOnlyDiv from "./ViewOnlyDiv";
import LateralField from "./LateralField";

const SideLabelIntegerInput = ({ label, fieldName, placeholder, formik, isDisabled, tooltip, ...otherProps }) => {
  const val = _.get(formik.values, fieldName);

  return (
    <LateralField label={label} tooltip={tooltip}>
      {isDisabled && <ViewOnlyDiv>{val}</ViewOnlyDiv>}
      {!isDisabled && <IntegerInput
        fullWidth
        fieldName={fieldName}
        placeholder={placeholder}
        {...otherProps}
      />}

    </LateralField>
  );
};
export default connect(SideLabelIntegerInput);
